import type { ReactElement } from 'react';
import type { DeviceStatus, SessionStatus } from '@opsrev/shared';
import { DEVICE_STATUS_LABEL, SESSION_STATUS_LABEL } from '../format';

export function DeviceStatusBadge({ status }: { status: DeviceStatus }): ReactElement {
  return <span className={`badge device-${status}`}>{DEVICE_STATUS_LABEL[status]}</span>;
}

export function SessionStatusChip({ status }: { status: SessionStatus }): ReactElement {
  return <span className={`chip session-${status}`}>{SESSION_STATUS_LABEL[status]}</span>;
}

export function Spinner({ label }: { label?: string }): ReactElement {
  return (
    <div className="loading-inline">
      <span className="spinner small" aria-label={label ?? 'Loading'} />
      {label ? <span className="muted">{label}</span> : null}
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}): ReactElement {
  return (
    <div className="card error-card">
      <p className="error-text">{message}</p>
      {onRetry ? (
        <button className="btn" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  hint,
}: {
  title: string;
  hint?: string;
}): ReactElement {
  return (
    <div className="empty-state">
      <p className="empty-title">{title}</p>
      {hint ? <p className="muted">{hint}</p> : null}
    </div>
  );
}
